

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

import Loader from "../../utils/Loader";

import { getInscricoes } from "../../services/inscricoesService";

function Inscricoes() {

  const navigate = useNavigate();

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [inscricoes, setInscricoes ] = useState([]);
  const [inscricoesHoje, setInscricoesHoje ] = useState([]);
  const [inscricoesOntem, setInscricoesOntem ] = useState([]);

  const [inscricoesMesAtual, setInscricoesMesAtual] = useState([]); // 2026-06-05
  const [inscricoesMesAnterior, setInscricoesMesAnterior] = useState([]); // 2026-06-05


  const positivo = (
    <svg
      className="icon icon-xs text-success"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  const negativo = (
    <svg
      className="icon icon-xs text-danger"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );


  useEffect(() => {  
    const token = localStorage.getItem("token");

    setIsLoading(true);


    getInscricoes(token)
      .then((response) => {

        // console.log("getInscricoes: ", response);

        const today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
        day = day.toString().padStart(2, "0"); // 2025-11-04
        month = month.toString().padStart(2, "0"); // 2026-01-08

        let current_month = month; // 2026-09-01

        // console.log("current_month: ", current_month);

        let data_hoje = "";
        data_hoje = data_hoje.concat(day, "-", month, "-", year, "");

        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
  
        year = yesterday .getFullYear();
        month = yesterday .getMonth() + 1;
        day = yesterday .getDate();
        day = day.toString().padStart(2, "0"); // 2025-11-04
        month = month.toString().padStart(2, "0"); // 2026-01-08

        // let last_month = month; // 2026-09-01

        // console.log("last_month: ", last_month);

        let data_ontem = "";
        data_ontem = data_ontem.concat(day, "-", month, "-", year, "");


        // console.log("H: ", data_hoje);
        // console.log("O: ", data_ontem);

        setInscricoes(response);
        setInscricoesHoje(response.filter((inscricao) => {return inscricao.data_perfil === data_hoje}))
        setInscricoesOntem(response.filter((inscricao) => {return inscricao.data_perfil === data_ontem}))

	//2026-09-01
        //setInscricoesMesAtual(response.filter((inscricao) => {return inscricao.data_perfil.includes("-" + month + "-")})); // 2026-06-05
        setInscricoesMesAtual(response.filter((inscricao) => {return inscricao.data_perfil.includes("-" + current_month + "-")}));
	//2026-09-01        
        //setInscricoesMesAnterior(response.filter((inscricao) => {return !inscricao.data_perfil.includes("-" + month + "-")}));  // 2026-06-05
        //setInscricoesMesAnterior(response.filter((inscricao) => {return inscricao.data_perfil.includes("-" + last_month + "-")}));
        setInscricoesMesAnterior(response.filter((inscricao) => {return !inscricao.data_perfil.includes("-" + current_month + "-")}));

        setIsLoading(false);
        
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        //setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      });

  }, [refresh]);


  return (
    <>
      { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
      <main className="content">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
              <div className="d-block mb-md-0">
                <h1 className="h4">Inscrições</h1>
              </div>
              <div>
                <button
                  onClick={() => {
                    setRefresh((r) => !r);
                  }}
                >
                  Atualizar
                </button>
              </div>
            </div>


<div className="row">

  <div className="col-12 col-sm-6 col-xl-4 mt-2">  
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">
          
          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Inscrições/reinsc. do mês</h4>
              <h3 className="mb-1">
                {inscricoesMesAtual.length}
              </h3>
            </div>
          </div>
          
          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Inscrições/reinscrições do mês</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAtual.length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div> 
  </div>

  <div className="col-12 col-sm-6 col-xl-4 mt-2">  
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">
          
          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Inscrições</h4>
              <h3 className="mb-1">
                {inscricoesMesAtual.filter((inscricao) => {return inscricao.insc_reinsc === 'INSC'}).length}
              </h3>
            </div>
          </div>
          
          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Inscrições</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAtual.filter((inscricao) => {return inscricao.insc_reinsc === 'INSC'}).length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div> 
  </div>
  
  <div className="col-12 col-sm-6 col-xl-4 mt-2">
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">
          
          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Reinscrições</h4>
              <h3 className="mb-1">
                {inscricoesMesAtual.filter((inscricao) => {return inscricao.insc_reinsc === 'REINSC'}).length}
              </h3>
            </div>
          </div>
          
          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Reinscrições</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAtual.filter((inscricao) => {return inscricao.insc_reinsc === 'REINSC'}).length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div> 
  </div>

</div>



            {/*<div className="card card-body border-0 shadow mt-2 mb-2">
              <h5 className="h6 fw-bold">Inscricões/reinscrições, hoje (#{inscricoes.filter((inscricao) => {return inscricao.data_perfil === '22-10-2025'}).length})</h5>

              <div className="row mt-4">
              {
                inscricoes.length > 0 && inscricoesHoje.map(inscricao => {

                  const sucesso = "none";
                  const insucesso = "4px solid #ff4000"; // #ee82ee
                  const info = "4px solid #ffa500";


                  const status = inscricao.inscricao_status === 1 ? "#00cc00" : "#ff4000" ; // "#f0bc74" "#3cb371" "#ee82ee" "#80ff80"

                  const borderInscricao = inscricao.inscricao_OK === 1 ? sucesso : insucesso;
                  const borderQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const borderDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const borderIBAN = inscricao.IBAN_OK === 1 ? sucesso : inscricao.cod_modalidade === 5 ? insucesso : info;
                  const borderContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  const paddingInscricao = inscricao.inscricao_OK === 1 ? sucesso : "5px";
                  const paddingQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const paddingDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const paddingIBAN = inscricao.IBAN_OK === 1 ? sucesso : "5px";
                  const paddingContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  return (
                    <div key={inscricao.cod_perfil} className="col-12 col-sm-6 col-xl-3">

                      <div className="card card-body py-3 border-2 mt-2 mb-2">
                        <div>
                          <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>


                          <p style={{marginBottom: ".5rem"}}><strong>{inscricao.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{inscricao.nome_completo}</span></p>
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderInscricao}`}}>Inscrição{inscricao.data_pagto_inscricao ? `: ${inscricao.data_pagto_inscricao} | €${inscricao.valor_inscricao}` : ''}</p>
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderQuota}`}}>Quota: {inscricao.data_pagto_quota ? `${inscricao.data_pagto_quota} | €${inscricao.valor_quota}` : 'X'}</p>
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderDiversos}`}}>Diversos: {inscricao.data_validade_serv ? `${inscricao.data_validade_serv}` : 'X'}</p>
                          
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderIBAN}`, paddingLeft: `${paddingIBAN}` }}>IBAN{inscricao.IBAN_OK ? ": OK" : ''}</p>

                          <p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`}}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>

                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>
            */}


            <div className="card card-body border-0 shadow mt-2 mb-2">
              <h5 className="h6 fw-bold">Hoje (#{inscricoesHoje.length})</h5>

              <div className="row mt-4">
              {
                inscricoesHoje.length > 0 && inscricoesHoje.map(inscricao => {

                  const sucesso = "none";
                  const insucesso = "4px solid #b32d00"; // #ee82ee   #ff4000
                  const info = "4px solid #ffa500";

                  const status = inscricao.inscricao_status === 1 ? "#00b300" : "#b32d00" ; // "#f0bc74" "#3cb371" "#ee82ee" "#80ff80" #ff4000

                  const status1 = (inscricao.protocolo_ENTIDADE !== null && inscricao.data_comprovativo_PROTOCOLO === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.data_comprovativo_IBAN === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.IBAN_OK === false) ||
                                  (inscricao.data_contrato === null && inscricao.data_ficha_inscricao === null)
                                  ? "#b32d00"
                                  : "#00b300";

                  const borderInscricao = inscricao.inscricao_OK === 1 ? sucesso : insucesso;
                  const borderQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const borderDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const borderIBAN = inscricao.IBAN_OK === 1 ? sucesso : inscricao.cod_modalidade === 5 ? insucesso : info;
                  const borderContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  const borderFichaContrato = inscricao.ficha_contrato_status && inscricao.ficha_contrato_status !== '0' ? sucesso : insucesso;
                  const borderComprovativoIBAN = inscricao.comprovativo_iban_status && inscricao.comprovativo_iban_status === '-'  ? info : inscricao.comprovativo_iban_status === '0' ? insucesso : sucesso;
                  const borderComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 && inscricao.comprovativo_protocolo_status1 === '-'  ? info : inscricao.comprovativo_protocolo_status1 === '0' ? insucesso : sucesso;

                  const paddingInscricao = inscricao.inscricao_OK === 1 ? sucesso : "5px";
                  const paddingQuota = inscricao.quota_OK === 1 ? sucesso : "5px";
                  const paddingDiversos = inscricao.diversos_OK === 1 ? sucesso : "5px";
                  const paddingIBAN = inscricao.IBAN_OK === 1 ? sucesso : "5px";
                  const paddingContrato = inscricao.contrato_OK === 1 ? sucesso : "5px";

                  const paddingComprovativoIBAN = inscricao.comprovativo_iban_status === '0' || inscricao.comprovativo_iban_status === '-' ? "5px" : sucesso;
                  const paddingComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 === '0' || inscricao.comprovativo_protocolo_status1 === '-' ? "5px" : sucesso;

                  return (
                    <div key={inscricao.cod_perfil} className="col-12 col-sm-6 col-xl-3">

                      <div className="card card-body py-3 border-2 mt-2 mb-2">
                        <div>

                          {inscricao.inscricao_status !== undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}
                          {inscricao.inscricao_status === undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status1}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}

                          <p style={{marginBottom: ".5rem"}}><strong>{inscricao.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{inscricao.nome_completo}</span></p>
                          {inscricao.data_pagto_inscricao !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderInscricao}`, paddingLeft: `${paddingInscricao}` }}>Inscrição{inscricao.data_pagto_inscricao ? `: ${inscricao.data_pagto_inscricao} | €${inscricao.valor_inscricao}` : ''}</p>}
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderQuota}`, paddingLeft: `${paddingQuota}` }}>Quota{inscricao.data_pagto_quota ? `: ${inscricao.data_pagto_quota} | €${inscricao.valor_quota}` : ''}</p>
                          {inscricao.data_validade_serv !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderDiversos}`, paddingLeft: `${paddingDiversos}` }}>Diversos{inscricao.data_validade_serv ? `: ${inscricao.data_validade_serv}` : ''}</p>}
                          
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderIBAN}`, paddingLeft: `${paddingIBAN}` }}>IBAN{inscricao.IBAN_OK === 1 ? ": OK" : ''}</p>

                          {/*<p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>*/}

                          {inscricao.comprovativo_iban_status && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoIBAN}`, paddingLeft: `${paddingComprovativoIBAN}` }}>Comprovativo de IBAN{inscricao.comprovativo_iban_status === '-' ? "" : inscricao.comprovativo_iban_status === '0' ? "" : `: ${inscricao.comprovativo_iban_status}`}</p>}
                          {inscricao.comprovativo_protocolo_status1 && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoProtocolo}`, paddingLeft: `${paddingComprovativoProtocolo}` }}>Comprovativo de protocolo{inscricao.comprovativo_protocolo_status1 === '-' ? "" : inscricao.comprovativo_protocolo_status1 === '0' ? `: (${inscricao.protocolo_ENTIDADE})` : `: ${inscricao.comprovativo_protocolo_status1}`}</p>}

                          {inscricao.data_documento !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>}
                          {inscricao.ficha_contrato_status !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderFichaContrato}`, paddingLeft: `${paddingContrato}` }}>
			    {inscricao.ficha_contrato_status !== '0'
			     ? inscricao.ficha_contrato_status.substring(0,2) === 'F-'
			       ? `F. Inscrição: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.ficha_inscricao_colaborador})` 
                               : `Contrato: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.contrato_colaborador})` 
                             : 'F. Inscrição ou contrato'}</p>}

                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>



            <div className="card card-body border-0 shadow mt-2 mb-2">
              <h5 className="h6 fw-bold">Ontem (#{inscricoesOntem.length})</h5>

              <div className="row mt-4">
              {
                inscricoesOntem.length > 0 && inscricoesOntem.map(inscricao => {

                  const sucesso = "none";
                  const insucesso = "4px solid #b32d00"; // #ee82ee   #ff4000
                  const info = "4px solid #ffa500";

                  const status = inscricao.inscricao_status === 1 ? "#00b300" : "#b32d00" ; // "#f0bc74" "#3cb371" "#ee82ee" "#80ff80" #ff4000

                  const status1 = (inscricao.protocolo_ENTIDADE !== null && inscricao.data_comprovativo_PROTOCOLO === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.data_comprovativo_IBAN === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.IBAN_OK === false) ||
                                  (inscricao.data_contrato === null && inscricao.data_ficha_inscricao === null)
                                  ? "#b32d00"
                                  : "#00b300";

                  const borderInscricao = inscricao.inscricao_OK === 1 ? sucesso : insucesso;
                  const borderQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const borderDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const borderIBAN = inscricao.IBAN_OK === 1 ? sucesso : inscricao.cod_modalidade === 5 ? insucesso : info;
                  const borderContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  const borderFichaContrato = inscricao.ficha_contrato_status && inscricao.ficha_contrato_status !== '0' ? sucesso : insucesso;

                  const borderComprovativoIBAN = inscricao.comprovativo_iban_status && inscricao.comprovativo_iban_status === '-'  ? info : inscricao.comprovativo_iban_status === '0' ? insucesso : sucesso;
                  const borderComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 && inscricao.comprovativo_protocolo_status1 === '-'  ? info : inscricao.comprovativo_protocolo_status1 === '0' ? insucesso : sucesso;

                  const paddingInscricao = inscricao.inscricao_OK === 1 ? sucesso : "5px";
                  const paddingQuota = inscricao.quota_OK === 1 ? sucesso : "5px";
                  const paddingDiversos = inscricao.diversos_OK === 1 ? sucesso : "5px";
                  const paddingIBAN = inscricao.IBAN_OK === 1 ? sucesso : "5px";
                  const paddingContrato = inscricao.contrato_OK === 1 ? sucesso : "5px";

                  const paddingComprovativoIBAN = inscricao.comprovativo_iban_status === '0' || inscricao.comprovativo_iban_status === '-' ? "5px" : sucesso;
                  const paddingComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 === '0' || inscricao.comprovativo_protocolo_status1 === '-' ? "5px" : sucesso;

                  return (
                    <div key={inscricao.cod_perfil} className="col-12 col-sm-6 col-xl-3">

                      <div style={{backgroundColor: "#f2f2f2"}} className="card card-body py-3 border-2 mt-2 mb-2">
                        <div>

                          {inscricao.inscricao_status !== undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}
                          {inscricao.inscricao_status === undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status1}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}

                          <p style={{marginBottom: ".5rem"}}><strong>{inscricao.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{inscricao.nome_completo}</span></p>
                          {inscricao.data_pagto_inscricao !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderInscricao}`, paddingLeft: `${paddingInscricao}` }}>Inscrição{inscricao.data_pagto_inscricao ? `: ${inscricao.data_pagto_inscricao} | €${inscricao.valor_inscricao}` : ''}</p>}
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderQuota}`, paddingLeft: `${paddingQuota}` }}>Quota{inscricao.data_pagto_quota ? `: ${inscricao.data_pagto_quota} | €${inscricao.valor_quota}` : ''}</p>
                          {inscricao.data_validade_serv !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderDiversos}`, paddingLeft: `${paddingDiversos}` }}>Diversos{inscricao.data_validade_serv ? `: ${inscricao.data_validade_serv}` : ''}</p>}
                          
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderIBAN}`, paddingLeft: `${paddingIBAN}` }}>IBAN{inscricao.IBAN_OK ? ": OK" : ''}</p>

                          {inscricao.comprovativo_iban_status && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoIBAN}`, paddingLeft: `${paddingComprovativoIBAN}` }}>Comprovativo de IBAN{inscricao.comprovativo_iban_status === '-' ? "" : inscricao.comprovativo_iban_status === '0' ? "" : `: ${inscricao.comprovativo_iban_status}`}</p>}
                          {inscricao.comprovativo_protocolo_status1 && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoProtocolo}`, paddingLeft: `${paddingComprovativoProtocolo}` }}>Comprovativo de protocolo{inscricao.comprovativo_protocolo_status1 === '-' ? "" : inscricao.comprovativo_protocolo_status1 === '0' ? `: (${inscricao.protocolo_ENTIDADE})` : `: ${inscricao.comprovativo_protocolo_status1}`}</p>}

                          {inscricao.data_documento !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>}
                          {inscricao.ficha_contrato_status !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderFichaContrato}`, paddingLeft: `${paddingContrato}` }}>
			    {inscricao.ficha_contrato_status !== '0'
			     ? inscricao.ficha_contrato_status.substring(0,2) === 'F-'
			       ? `F. Inscrição: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.ficha_inscricao_colaborador})` 
                               : `Contrato: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.contrato_colaborador})` 
                             : 'F. Inscrição ou contrato'}</p>}


                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>

            {/* 2026-02-09 Inscrições do mês atual */}
            <div className="card card-body border-0 shadow mt-2 mb-2">
              <h5 className="h6 fw-bold">Mês atual (#{inscricoesMesAtual.length})</h5>

              <div className="row mt-4">
              {
                inscricoesMesAtual.length > 0 && inscricoesMesAtual.map(inscricao => {

                  const sucesso = "none";
                  const insucesso = "4px solid #b32d00"; // #ee82ee   #ff4000
                  const info = "4px solid #ffa500";


                  const status = inscricao.inscricao_status === 1 ? "#00b300" : "#b32d00" ; // "#f0bc74" "#3cb371" "#ee82ee" "#80ff80" #ff4000

                  const status1 = (inscricao.protocolo_ENTIDADE !== null && inscricao.data_comprovativo_PROTOCOLO === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.data_comprovativo_IBAN === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.IBAN_OK === false) ||
                                  (inscricao.data_contrato === null && inscricao.data_ficha_inscricao === null)
                                  ? "#b32d00"
                                  : "#00b300";

                  const borderInscricao = inscricao.inscricao_OK === 1 ? sucesso : insucesso;
                  const borderQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const borderDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const borderIBAN = inscricao.IBAN_OK === 1 ? sucesso : inscricao.cod_modalidade === 5 ? insucesso : info;
                  const borderContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  const borderFichaContrato = inscricao.ficha_contrato_status && inscricao.ficha_contrato_status !== '0' ? sucesso : insucesso;

                  const borderComprovativoIBAN = inscricao.comprovativo_iban_status && inscricao.comprovativo_iban_status === '-'  ? info : inscricao.comprovativo_iban_status === '0' ? insucesso : sucesso;
                  const borderComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 && inscricao.comprovativo_protocolo_status1 === '-'  ? info : inscricao.comprovativo_protocolo_status1 === '0' ? insucesso : sucesso;

                  const paddingInscricao = inscricao.inscricao_OK === 1 ? sucesso : "5px";
                  const paddingQuota = inscricao.quota_OK === 1 ? sucesso : "5px";
                  const paddingDiversos = inscricao.diversos_OK === 1 ? sucesso : "5px";
                  const paddingIBAN = inscricao.IBAN_OK === 1 ? sucesso : "5px";
                  const paddingContrato = inscricao.contrato_OK === 1 ? sucesso : "5px";

                  const paddingComprovativoIBAN = inscricao.comprovativo_iban_status === '0' || inscricao.comprovativo_iban_status === '-' ? "5px" : sucesso;
                  const paddingComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 === '0' || inscricao.comprovativo_protocolo_status1 === '-' ? "5px" : sucesso;

                  return (
                    <div key={inscricao.cod_perfil} className="col-12 col-sm-6 col-xl-3">

                      <div style={{backgroundColor: "#f2f2f2"}} className="card card-body py-3 border-2 mt-2 mb-2">
                        <div>

                          {inscricao.inscricao_status !== undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}
                          {inscricao.inscricao_status === undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status1}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}


                          <p style={{marginBottom: ".5rem"}}><strong>{inscricao.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{inscricao.nome_completo}</span></p>
                          {inscricao.data_pagto_inscricao !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderInscricao}`, paddingLeft: `${paddingInscricao}` }}>Inscrição{inscricao.data_pagto_inscricao ? `: ${inscricao.data_pagto_inscricao} | €${inscricao.valor_inscricao}` : ''}</p>}
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderQuota}`, paddingLeft: `${paddingQuota}` }}>Quota{inscricao.data_pagto_quota ? `: ${inscricao.data_pagto_quota} | €${inscricao.valor_quota}` : ''}</p>
                          {inscricao.data_validade_serv !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderDiversos}`, paddingLeft: `${paddingDiversos}` }}>Diversos{inscricao.data_validade_serv ? `: ${inscricao.data_validade_serv}` : ''}</p>}
                          
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderIBAN}`, paddingLeft: `${paddingIBAN}` }}>IBAN{inscricao.IBAN_OK ? ": OK" : ''}</p>

                          {inscricao.comprovativo_iban_status && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoIBAN}`, paddingLeft: `${paddingComprovativoIBAN}` }}>Comprovativo de IBAN{inscricao.comprovativo_iban_status === '-' ? "" : inscricao.comprovativo_iban_status === '0' ? "" : `: ${inscricao.comprovativo_iban_status}`}</p>}
                          {inscricao.comprovativo_protocolo_status1 && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoProtocolo}`, paddingLeft: `${paddingComprovativoProtocolo}` }}>Comprovativo de protocolo{inscricao.comprovativo_protocolo_status1 === '-' ? "" : inscricao.comprovativo_protocolo_status1 === '0' ? `: (${inscricao.protocolo_ENTIDADE})`  : `: ${inscricao.comprovativo_protocolo_status1}`}</p>}

                          {/*<p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>*/}

                          {inscricao.data_documento !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>}
                          {inscricao.ficha_contrato_status !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderFichaContrato}`, paddingLeft: `${paddingContrato}` }}>
			    {inscricao.ficha_contrato_status !== '0'
			     ? inscricao.ficha_contrato_status.substring(0,2) === 'F-'
			       ? `F. Inscrição: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.ficha_inscricao_colaborador})` 
                               : `Contrato: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.contrato_colaborador})` 
                             : 'F. Inscrição ou contrato'}</p>}

                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>


            {/* 2026-06-05 Inscrições do mês anterior */}


            {/* Resumo */}


<div className="row">                                                                                                                                                                                                                                                                                                                                                                   
  <div className="col-12 col-sm-6 col-xl-4 mt-2">
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">

          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Inscrições/reinsc. do mês anterior</h4>
              <h3 className="mb-1">
                {inscricoesMesAnterior.length}
              </h3>
            </div>
          </div>

          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Inscrições/reinscrições do mês anterior</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAnterior.length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div className="col-12 col-sm-6 col-xl-4 mt-2">
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">

          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Inscrições</h4>
              <h3 className="mb-1">
                {inscricoesMesAnterior.filter((inscricao) => {return inscricao.insc_reinsc === 'INSC'}).length}
              </h3>
            </div>
          </div>

          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Inscrições</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAnterior.filter((inscricao) => {return inscricao.insc_reinsc === 'INSC'}).length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div className="col-12 col-sm-6 col-xl-4 mt-2">
    <div className="card border-0 shadow">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">

          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">

            <div className="icon-shape icon-shape-secondary rounded me-2 me-sm-0">
              <svg className="icon" width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 6.25C12.8358 6.25 12.5 6.58579 12.5 7C12.5 7.41421 12.8358 7.75 13.25 7.75H15.1893L11.4697 11.4697L7.75 15.1893V13.25C7.75 12.8358 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.8358 6.25 13.25V17C6.25 17.4142 6.58579 17.75 7 17.75H10.75C11.1642 17.75 11.5 17.4142 11.5 17C11.5 16.5858 11.1642 16.25 10.75 16.25H8.81066L12.5303 12.5303L16.25 8.81066V10.75C16.25 11.1642 16.5858 11.5 17 11.5C17.4142 11.5 17.75 11.1642 17.75 10.75V7C17.75 6.58579 17.4142 6.25 17 6.25H13.25Z" fill="#1C274C"/>
              </svg>
            </div>

            <div className="d-sm-none">
              <h4 className="fw-extrabold h5">Reinscrições</h4>
              <h3 className="mb-1">
                {inscricoesMesAnterior.filter((inscricao) => {return inscricao.insc_reinsc === 'REINSC'}).length}
              </h3>
            </div>
          </div>

          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h6 text-gray-400 mb-0">Reinscrições</h2>
              <h3 className="fw-extrabold mb-2">
                {inscricoesMesAnterior.filter((inscricao) => {return inscricao.insc_reinsc === 'REINSC'}).length}
              </h3>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>



            {/* Detalhes */}



            {inscricoesMesAnterior.length > 0 && <div className="card card-body border-0 shadow mt-2 mb-2">
              <h5 className="h6 fw-bold">Mês anterior (#{inscricoesMesAnterior.length})</h5>

              <div className="row mt-4">
              {
                inscricoesMesAnterior.length > 0 && inscricoesMesAnterior.map(inscricao => {

                  const sucesso = "none";
                  const insucesso = "4px solid #b32d00"; // #ee82ee   #ff4000
                  const info = "4px solid #ffa500";


                  const status = inscricao.inscricao_status === 1 ? "#00b300" : "#b32d00" ; // "#f0bc74" "#3cb371" "#ee82ee" "#80ff80" #ff4000

                  const status1 = (inscricao.protocolo_ENTIDADE !== null && inscricao.data_comprovativo_PROTOCOLO === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.data_comprovativo_IBAN === null) ||
                                  (inscricao.cod_modalidade === 5 && inscricao.IBAN_OK === false) ||
                                  (inscricao.data_contrato === null && inscricao.data_ficha_inscricao === null)
                                  ? "#b32d00"
                                  : "#00b300";

                  const borderInscricao = inscricao.inscricao_OK === 1 ? sucesso : insucesso;
                  const borderQuota = inscricao.quota_OK === 1 ? sucesso : insucesso;
                  const borderDiversos = inscricao.diversos_OK === 1 ? sucesso : insucesso;
                  const borderIBAN = inscricao.IBAN_OK === 1 ? sucesso : inscricao.cod_modalidade === 5 ? insucesso : info;
                  const borderContrato = inscricao.contrato_OK === 1 ? sucesso : insucesso;

                  const borderFichaContrato = inscricao.ficha_contrato_status && inscricao.ficha_contrato_status !== '0' ? sucesso : insucesso;

                  const borderComprovativoIBAN = inscricao.comprovativo_iban_status && inscricao.comprovativo_iban_status === '-'  ? info : inscricao.comprovativo_iban_status === '0' ? insucesso : sucesso;
                  const borderComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 && inscricao.comprovativo_protocolo_status1 === '-'  ? info : inscricao.comprovativo_protocolo_status1 === '0' ? insucesso : sucesso;

                  const paddingInscricao = inscricao.inscricao_OK === 1 ? sucesso : "5px";
                  const paddingQuota = inscricao.quota_OK === 1 ? sucesso : "5px";
                  const paddingDiversos = inscricao.diversos_OK === 1 ? sucesso : "5px";
                  const paddingIBAN = inscricao.IBAN_OK === 1 ? sucesso : "5px";
                  const paddingContrato = inscricao.contrato_OK === 1 ? sucesso : "5px";

                  const paddingComprovativoIBAN = inscricao.comprovativo_iban_status === '0' || inscricao.comprovativo_iban_status === '-' ? "5px" : sucesso;
                  const paddingComprovativoProtocolo = inscricao.comprovativo_protocolo_status1 === '0' || inscricao.comprovativo_protocolo_status1 === '-' ? "5px" : sucesso;

                  return (
                    <div key={inscricao.cod_perfil} className="col-12 col-sm-6 col-xl-3">

                      <div style={{backgroundColor: "#f2f2f2"}} className="card card-body py-3 border-2 mt-2 mb-2">
                        <div>

                          {inscricao.inscricao_status !== undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}
                          {inscricao.inscricao_status === undefined && <p style={{marginBottom: ".5rem", color : "white", backgroundColor: `${status1}`, textAlign : "center", borderRadius: "5px" }}>{inscricao.insc_reinsc === 'INSC' ? 'INSC' : 'REINSC'}</p>}


                          <p style={{marginBottom: ".5rem"}}><strong>{inscricao.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{inscricao.nome_completo}</span></p>
                          {inscricao.data_pagto_inscricao !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderInscricao}`, paddingLeft: `${paddingInscricao}` }}>Inscrição{inscricao.data_pagto_inscricao ? `: ${inscricao.data_pagto_inscricao} | €${inscricao.valor_inscricao}` : ''}</p>}
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderQuota}`, paddingLeft: `${paddingQuota}` }}>Quota{inscricao.data_pagto_quota ? `: ${inscricao.data_pagto_quota} | €${inscricao.valor_quota}` : ''}</p>
                          {inscricao.data_validade_serv !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderDiversos}`, paddingLeft: `${paddingDiversos}` }}>Diversos{inscricao.data_validade_serv ? `: ${inscricao.data_validade_serv}` : ''}</p>}
                          
                          <p style={{marginBottom: ".5rem", borderLeft: `${borderIBAN}`, paddingLeft: `${paddingIBAN}` }}>IBAN{inscricao.IBAN_OK ? ": OK" : ''}</p>

                          {inscricao.comprovativo_iban_status && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoIBAN}`, paddingLeft: `${paddingComprovativoIBAN}` }}>Comprovativo de IBAN{inscricao.comprovativo_iban_status === '-' ? "" : inscricao.comprovativo_iban_status === '0' ? "" : `: ${inscricao.comprovativo_iban_status}`}</p>}
                          {inscricao.comprovativo_protocolo_status1 && <p style={{marginBottom: ".5rem", borderLeft: `${borderComprovativoProtocolo}`, paddingLeft: `${paddingComprovativoProtocolo}` }}>Comprovativo de protocolo{inscricao.comprovativo_protocolo_status1 === '-' ? "" : inscricao.comprovativo_protocolo_status1 === '0' ? `: (${inscricao.protocolo_ENTIDADE})`  : `: ${inscricao.comprovativo_protocolo_status1}`}</p>}

                          {/*<p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>*/}

                          {inscricao.data_documento !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderContrato}`, paddingLeft: `${paddingContrato}` }}>Contrato{inscricao.data_documento ? `: ${inscricao.data_documento} (${inscricao.Colaborador})` : ''}</p>}
                          {inscricao.ficha_contrato_status !== undefined && <p style={{marginBottom: ".5rem", borderLeft: `${borderFichaContrato}`, paddingLeft: `${paddingContrato}` }}>
			    {inscricao.ficha_contrato_status !== '0'
			     ? inscricao.ficha_contrato_status.substring(0,2) === 'F-'
			       ? `F. Inscrição: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.ficha_inscricao_colaborador})` 
                               : `Contrato: ${inscricao.ficha_contrato_status.substring(2)} (${inscricao.contrato_colaborador})` 
                             : 'F. Inscrição ou contrato'}</p>}

                        </div>
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>}


          </>
        )}
      </main>
    </>
  );
}

export default Inscricoes;
